<div class="bg-white/95 dark:bg-luxury-navy/95 backdrop-blur-xl rounded-xl shadow-luxury overflow-hidden border border-gray-200/50 dark:border-primary-800/20">
  <div class="overflow-x-auto">
    <table class="w-full">
      <thead class="listing-thead">
        <tr>
          <th
            *ngFor="let column of columns"
            [class.text-left]="!column.align || column.align === 'left'"
            [class.text-center]="column.align === 'center'"
            [class.text-right]="column.align === 'right'"
            [style.width]="column.width"
            class="px-6 py-3 text-xs font-medium text-white dark:text-primary-100 uppercase tracking-wider"
          >
            {{ column.label }}
          </th>
        </tr>
      </thead>
      <tbody [class.divide-y]="striped" [class.divide-gray-200]="striped" [class.dark:divide-gray-700]="striped">
        <!-- Loading State -->
        <tr *ngIf="isLoading">
          <td [attr.colspan]="columns.length" class="px-6 py-8 text-center">
            <ng-container *ngIf="loadingTemplate; else defaultLoading">
              <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
            </ng-container>
            <ng-template #defaultLoading>
              <div class="flex justify-center">
                <svg class="animate-spin h-8 w-8 text-primary-600" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </div>
            </ng-template>
          </td>
        </tr>

        <!-- Empty State -->
        <tr *ngIf="!isLoading && data.length === 0">
          <td [attr.colspan]="columns.length" class="px-6 py-8 text-center text-gray-500 dark:text-gray-400">
            <ng-container *ngIf="emptyTemplate; else defaultEmpty">
              <ng-container *ngTemplateOutlet="emptyTemplate"></ng-container>
            </ng-container>
            <ng-template #defaultEmpty>
              {{ emptyMessage }}
            </ng-template>
          </td>
        </tr>

        <!-- Data Rows -->
        <ng-container *ngIf="!isLoading && data.length > 0">
          <ng-container *ngIf="rowTemplate; else defaultRow">
            <tr
              *ngFor="let row of data; let i = index; trackBy: trackByRow"
              [style.animation-delay]="(i * 30) + 'ms'"
              [class.bg-gray-50]="striped && i % 2 === 0"
              [class.dark:bg-gray-700]="striped && i % 2 === 0"
              [class.hover:bg-gray-50]="hover"
              [class.dark:hover:bg-gray-700]="hover"
              class="animate-row-in transition-all duration-200 hover:shadow-md hover:translate-y-[-1px]"
            >
              <ng-container *ngTemplateOutlet="rowTemplate; context: { $implicit: row, index: i }"></ng-container>
            </tr>
          </ng-container>
          <ng-template #defaultRow>
            <tr
              *ngFor="let row of data; let i = index; trackBy: trackByRow"
              [style.animation-delay]="(i * 30) + 'ms'"
              [class.bg-gray-50]="striped && i % 2 === 0"
              [class.dark:bg-gray-700]="striped && i % 2 === 0"
              [class.hover:bg-gray-50]="hover"
              [class.dark:hover:bg-gray-700]="hover"
              class="animate-row-in transition-all duration-200 hover:shadow-md hover:translate-y-[-1px]"
            >
              <td
                *ngFor="let column of columns"
                [class.text-left]="!column.align || column.align === 'left'"
                [class.text-center]="column.align === 'center'"
                [class.text-right]="column.align === 'right'"
                class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white"
              >
                {{ row[column.key] }}
              </td>
            </tr>
          </ng-template>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
